import { ThemeProvider } from 'styled-components';
import {
  Button,
  BUTTON_SIZES,
  BUTTON_TYPES,
  BUTTON_VARIANTS,
  theme,
} from '@web-stories-wp/design-system';
import { LoadingIndicator } from '@components/loading';
import { useStoryEditor } from '@hooks';
import useAnimatedThumbnailEditor from './useAnimatedThumbnailEditor';

import './AnimatedThumbnailEditor.css';

const AnimatedThumbnailEditor = () => {
  const animatedThumbnail = useAnimatedThumbnailEditor();
  const { isLoading: isStoryEditorLoading, storyEditor } = useStoryEditor({
    animatedThumbnail,
  });

  if (animatedThumbnail.isLoading || isStoryEditorLoading) {
    return <LoadingIndicator />;
  }

  if (animatedThumbnail.loadError) {
    return (
      <ThemeProvider theme={theme}>
        <div className="AnimatedThumbnailEditor__message" role="alert">
          <h2>Animated thumbnail unavailable</h2>
          <p>
            The source or current animated-thumbnail state could not be loaded.
          </p>
          <div className="AnimatedThumbnailEditor__messageActions">
            <Button
              onClick={animatedThumbnail.retry}
              size={BUTTON_SIZES.SMALL}
              type={BUTTON_TYPES.SECONDARY}
              variant={BUTTON_VARIANTS.RECTANGLE}
            >
              Retry
            </Button>
            <Button
              onClick={animatedThumbnail.discard}
              size={BUTTON_SIZES.SMALL}
              type={BUTTON_TYPES.SECONDARY}
              variant={BUTTON_VARIANTS.RECTANGLE}
            >
              Back to CMS
            </Button>
          </div>
        </div>
      </ThemeProvider>
    );
  }

  if (!animatedThumbnail.source) {
    return (
      <ThemeProvider theme={theme}>
        <div className="AnimatedThumbnailEditor__message" role="status">
          <h2>Animated thumbnail unavailable</h2>
          <p>
            The current Story or Clip does not have a playable MP4 source. Its
            static thumbnail will remain in use.
          </p>
          <div className="AnimatedThumbnailEditor__messageActions">
            <Button
              onClick={animatedThumbnail.discard}
              size={BUTTON_SIZES.SMALL}
              type={BUTTON_TYPES.SECONDARY}
              variant={BUTTON_VARIANTS.RECTANGLE}
            >
              Back to CMS
            </Button>
          </div>
        </div>
      </ThemeProvider>
    );
  }

  return storyEditor;
};

export default AnimatedThumbnailEditor;
